import { render, staticRenderFns } from "./ListProducst.vue?vue&type=template&id=15ffb6aa&scoped=true"
import script from "./ListProducst.vue?vue&type=script&lang=js"
export * from "./ListProducst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ffb6aa",
  null
  
)

export default component.exports